import { render, staticRenderFns } from "./SummaryPage.vue?vue&type=template&id=40b3ccc4&scoped=true"
import script from "./SummaryPage.vue?vue&type=script&lang=js"
export * from "./SummaryPage.vue?vue&type=script&lang=js"
import style0 from "./SummaryPage.vue?vue&type=style&index=0&id=40b3ccc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b3ccc4",
  null
  
)

export default component.exports